module.exports = __webpack_public_path__ + "static/media/strutture-transenne-calcetto-vuote-noleggiocampi.3bf0b424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/strutture-di-contenimento/transenne/slider1/strutture-transenne-calcetto-vuote-noleggiocampi.jpg
// module id = 670
// module chunks = 0